import { render, staticRenderFns } from "./DeletePOIModal.vue?vue&type=template&id=06057945"
import script from "./DeletePOIModal.vue?vue&type=script&lang=js"
export * from "./DeletePOIModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports